import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { type LabelLink } from "@client/types";
import { type DotsMenuProps } from "./component";

export const getCurrentLink = (items: LabelLink[]): string => {
  if (!items.length) return "";

  const $window = $(window);
  const item = items.find((i) => {
    const elem = $(i.link);
    if (!elem.length) return false;

    const offset = elem.offset()!;
    const windowHeight = $window.height()!;
    const windowScrollTop = $window.scrollTop() || 0;

    return (
      offset.top - windowHeight / 3 < windowScrollTop &&
      offset.top + elem.height()! - windowHeight / 3 > windowScrollTop
    );
  });
  return item ? item.link! : "";
};

export const scrollToLink = (link: string) => {
  const scrollTop = $(link).offset()!.top;
  $("html, body").stop(true, true).animate(
    {
      scrollTop
    },
    500
  );
};

export const INVISIBLE_PROPS: DotsMenuProps & WithIsVisibleHOCProps = {
  isVisible: false,
  items: []
};
